import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";

export class EngineStatus extends Phaser.GameObjects.Container {

    private upperLabel0: Phaser.GameObjects.Text;
    private upperLabel1: Phaser.GameObjects.Text;
    private upperLabel2: Phaser.GameObjects.Text;
    private upperLabel3: Phaser.GameObjects.Text;
    private lowerLabel0: Phaser.GameObjects.Text;
    private lowerLabel1: Phaser.GameObjects.Text;
    private lowerLabel2: Phaser.GameObjects.Text;
    private lowerLabel3: Phaser.GameObjects.Text;
    private goldLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = - GameConstants.GAME_WIDTH / 2 + 35;
        this.y = GameConstants.GAME_HEIGHT / 2 - 80;

        // un recuadro negro por detrás
        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000);
        background.fillRect(-5, -5, 380, 75);
        this.add(background);

        this.upperLabel0 = new Phaser.GameObjects.Text(this.scene, 0, 0, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.upperLabel0);

        this.upperLabel1 = new Phaser.GameObjects.Text(this.scene, 90, 0, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.upperLabel1);

        this.upperLabel2 = new Phaser.GameObjects.Text(this.scene, 180, 0, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.upperLabel2);

        this.upperLabel3 = new Phaser.GameObjects.Text(this.scene, 270, 0, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.upperLabel3);

        this.lowerLabel0 = new Phaser.GameObjects.Text(this.scene, 0, 25, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.lowerLabel0);

        this.lowerLabel1 = new Phaser.GameObjects.Text(this.scene, 90, 25, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.lowerLabel1);

        this.lowerLabel2 = new Phaser.GameObjects.Text(this.scene, 180, 25, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.lowerLabel2);

        this.lowerLabel3 = new Phaser.GameObjects.Text(this.scene, 90, 50, "-", {fontFamily: "Arial", fontSize: "12px", color: "#FFFF00"});
        this.add(this.lowerLabel3);

        this.goldLabel = new Phaser.GameObjects.Text(this.scene, 0, 50, "gold:", {fontFamily: "Arial", fontSize: "12px", color: "#00FF00"});
        this.add(this.goldLabel);
    }

    public update(): void {

        if (!GameVars.cardCrawlEngine) {
            return;
        }
        
        const upperTableau = GameVars.cardCrawlEngine.getState().upperTableau;
        const lowerTableau = GameVars.cardCrawlEngine.getState().lowerTableau;

        if (upperTableau[0]) {
            this.upperLabel0.text = upperTableau[0].id + "-" + upperTableau[0].type + (upperTableau[0].value !== null ? "-" + upperTableau[0].value : "");
        } else {
            this.upperLabel0.text = "-";
        }

        if (upperTableau[1]) {
            this.upperLabel1.text = upperTableau[1].id + "-" + upperTableau[1].type + (upperTableau[1].value !== null ? "-" + upperTableau[1].value : "");
        } else {
            this.upperLabel1.text = "-";
        }

        if (upperTableau[2]) {
            this.upperLabel2.text = upperTableau[2].id + "-" + upperTableau[2].type + (upperTableau[2].value !== null ? "-" + upperTableau[2].value : "");
        } else {
            this.upperLabel2.text = "-";
        }

        if (upperTableau[3]) {
            this.upperLabel3.text = upperTableau[3].id + "-" + upperTableau[3].type + (upperTableau[3].value !== null ? "-" + upperTableau[3].value : "");
        } else {
            this.upperLabel3.text = "-";
        }

        if (lowerTableau[0]) {
            this.lowerLabel0.text = lowerTableau[0].id + "-" + lowerTableau[0].type + (lowerTableau[0].value !== null ? "-" + lowerTableau[0].value : "");
        } else {
            this.lowerLabel0.text = "-";
        }

        this.lowerLabel1.text = lowerTableau[1].id + "-" + lowerTableau[1].type + (lowerTableau[1].value !== null ? "-" + lowerTableau[1].value : "");
       
        if (lowerTableau[2]) {
            this.lowerLabel2.text = lowerTableau[2].id + "-" + lowerTableau[2].type + (lowerTableau[2].value !== null ? "-" + lowerTableau[2].value : "");
        } else {
            this.lowerLabel2.text = "-";
        }

        if (lowerTableau[3]) {
            this.lowerLabel3.text = lowerTableau[3].id + "-" + lowerTableau[3].type + (lowerTableau[3].value !== null ? "-" + lowerTableau[3].value : "");
        } else {
            this.lowerLabel3.text = "-";
        }

        this.goldLabel.text = "gold: " +  lowerTableau[1].gold;
    }
}
